import { render, staticRenderFns } from "./TrafficTrendsComponent.vue?vue&type=template&id=61c9366c&scoped=true"
import script from "./TrafficTrendsComponent.vue?vue&type=script&lang=js"
export * from "./TrafficTrendsComponent.vue?vue&type=script&lang=js"
import style0 from "./TrafficTrendsComponent.vue?vue&type=style&index=0&id=61c9366c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c9366c",
  null
  
)

export default component.exports